export default __webpack_public_path__ + "static/media/mike.46e4181b.png";